/* Политика конфиденциальности: лист снизу, «Коротко» сверху и раскрывающиеся разделы */
.privacy-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 1001;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  background: rgba(22, 40, 61, 0.6);
}

.privacy-modal-content {
  width: 100%;
  max-width: 560px;
  /* Фиксированная высота, а не только max-height: иначе в мобильном Safari тело не ограничивается и не прокручивается */
  height: min(92vh, 880px);
  max-height: 92vh;
  display: flex;
  flex-direction: column;
  border-radius: 22px 22px 0 0;
  background: #fff;
  color: #1f2a37;
  font-family: "Roboto Condensed", sans-serif;
  box-shadow: 0 -10px 30px -10px rgba(0, 0, 0, 0.5);
}

.privacy-modal-header {
  flex-shrink: 0;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 16px 12px 8px 20px;
}

.pp-head-text { flex: 1; min-width: 0; }

.privacy-modal-header h2 {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.15;
  text-align: left;
  text-transform: none;
  letter-spacing: normal;
  color: #1f2a37;
}

.pp-version { display: block; margin-top: 4px; font-size: 13px; color: #5b6673; }

.privacy-modal-close {
  width: 44px;
  height: 44px;
  border: 0;
  background: transparent;
  color: #5b6673;
  font-size: 28px;
  line-height: 1;
  cursor: pointer;
}

.pp-langs {
  flex-shrink: 0;
  display: flex;
  flex-wrap: nowrap;
  gap: 6px;
  padding: 0 20px 10px;
  border-bottom: 1px solid #e6ebf0;
  /* Девять языков не помещаются в ряд: полоса листается вбок */
  overflow-x: auto;
  scrollbar-width: none;
  -webkit-overflow-scrolling: touch;
}

.pp-langs::-webkit-scrollbar { display: none; }

.pp-lang {
  flex: 0 0 auto;
  min-width: 48px;
  min-height: 36px;
  border: 1px solid #cfd7e0;
  border-radius: 18px;
  background: #fff;
  color: #355980;
  font: inherit;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}

.pp-lang--active { border-color: #355980; background: #355980; color: #fff; }

.privacy-modal-body {
  flex: 1 1 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 14px 20px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
}

/* Дети тела не сжимаются: прокручивается тело, а не обрезаются разделы */
.privacy-modal-body > * { flex-shrink: 0; }

.pp-summary {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 14px;
  border-radius: 12px;
  background: #e6f4ec;
  color: #1f4d33;
  font-size: 14px;
  line-height: 1.4;
}

.pp-summary b { font-size: 15px; }

.pp-section {
  border: 1px solid #e1e6ee;
  border-radius: 12px;
  background: #fff;
}

.pp-section summary {
  position: relative;
  display: block;
  min-height: 48px;
  box-sizing: border-box;
  padding: 14px 44px 14px 14px;
  color: #1f2a37;
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  list-style: none;
  cursor: pointer;
}

.pp-section summary::-webkit-details-marker { display: none; }
.pp-section summary::after {
  content: "+";
  position: absolute;
  top: 12px;
  right: 16px;
  font-size: 22px;
  line-height: 24px;
  color: #355980;
}
.pp-section summary { border-radius: 11px; }
.pp-section[open] summary { border-radius: 11px 11px 0 0; background: #f3f6f9; }
.pp-section[open] summary::after { content: "\2212"; }

.pp-section ul {
  margin: 0;
  padding: 8px 14px 14px 32px;
  display: flex;
  flex-direction: column;
  gap: 7px;
  font-size: 14px;
  line-height: 1.4;
  color: #3a4654;
}

.pp-previous { margin: 4px 0 0; font-size: 12px; color: #8a94a0; text-align: center; }

.privacy-modal-actions {
  flex-shrink: 0;
  padding: 12px 20px calc(20px + env(safe-area-inset-bottom));
  border-top: 1px solid #e6ebf0;
}

.privacy-accept-button {
  width: 100%;
  min-height: 52px;
  border: 0;
  border-radius: 10px;
  background: #355980;
  color: #fff;
  font: inherit;
  font-size: 17px;
  font-weight: 700;
  cursor: pointer;
}

@supports (height: 1dvh) {
  .privacy-modal-content { height: min(92dvh, 880px); max-height: 92dvh; }
}

/* Широкий экран: окно по центру, а не лист у нижнего края */
@media (min-width: 1024px) {
  .privacy-modal-overlay {
    align-items: center;
    padding: 24px;
    box-sizing: border-box;
  }

  .privacy-modal-content {
    height: min(calc(100vh - 48px), 820px);
    border-radius: 22px;
    box-shadow: 0 30px 60px -20px rgba(0, 0, 0, 0.6);
  }
}
